"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXT_SIZE = exports.TEXT_SEGMENT = exports.TEXT_KIND = exports.TEXT_HEADING_LEVEL = exports.TEXT_FONT_WEIGHT = exports.TEXT_DISPLAY = exports.TEXT_DECORATION = exports.TEXT_OPACITY = exports.TEXT_COLOR = exports.TEXT_BORDER = exports.TEXT_ALIGN = void 0;
/* eslint-disable prettier/prettier  */
// React
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
// Components
const next13_enums_segments_1 = require("@gerenciatd/next13.enums.segments");
Object.defineProperty(exports, "TEXT_SEGMENT", { enumerable: true, get: function () { return next13_enums_segments_1.SEGMENT; } });
const next13_enums_colors_1 = __importStar(require("@gerenciatd/next13.enums.colors"));
Object.defineProperty(exports, "TEXT_COLOR", { enumerable: true, get: function () { return next13_enums_colors_1.COLOR_DICTIONARY; } });
Object.defineProperty(exports, "TEXT_OPACITY", { enumerable: true, get: function () { return next13_enums_colors_1.OPACITY; } });
// Utils
const utils_1 = require("./utils");
// Enums
const enums_1 = require("./enums");
Object.defineProperty(exports, "TEXT_ALIGN", { enumerable: true, get: function () { return enums_1.TEXT_ALIGN; } });
Object.defineProperty(exports, "TEXT_BORDER", { enumerable: true, get: function () { return enums_1.TEXT_BORDER; } });
Object.defineProperty(exports, "TEXT_DECORATION", { enumerable: true, get: function () { return enums_1.TEXT_DECORATION; } });
Object.defineProperty(exports, "TEXT_DISPLAY", { enumerable: true, get: function () { return enums_1.TEXT_DISPLAY; } });
Object.defineProperty(exports, "TEXT_FONT_WEIGHT", { enumerable: true, get: function () { return enums_1.TEXT_FONT_WEIGHT; } });
Object.defineProperty(exports, "TEXT_HEADING_LEVEL", { enumerable: true, get: function () { return enums_1.TEXT_HEADING_LEVEL; } });
Object.defineProperty(exports, "TEXT_KIND", { enumerable: true, get: function () { return enums_1.TEXT_KIND; } });
Object.defineProperty(exports, "TEXT_SIZE", { enumerable: true, get: function () { return enums_1.TEXT_SIZE; } });
const Text = (_a) => {
    var { component } = _a, restProps = __rest(_a, ["component"]);
    const Component = component;
    return react_1.default.createElement(Component, Object.assign({}, restProps));
};
/**
 * @name TextInfo
 * @description atomic component
 * @see {@link https://bit.cloud/gerenciatd/next13/components/text-info}
 * @param {any} props
 * @returns {React.FC}
 */
const COMPONENT_NAME = "TextInfo";
const TextInfo = (props) => {
    const { className = "", segment: segmentProp, kind, text, color, opacity, bgOpacity, backgroundColor, level, custoObjectInfo, cyData } = props, restProps = __rest(props, ["className", "segment", "kind", "text", "color", "opacity", "bgOpacity", "backgroundColor", "level", "custoObjectInfo", "cyData"]);
    const normalizedKind = (0, utils_1.getProperKind)(kind);
    if (!normalizedKind) {
        return null;
    }
    const segment = (0, next13_enums_segments_1.getNormalizedSegment)(segmentProp);
    const colorOpacity = (0, next13_enums_colors_1.default)(color, opacity, segment);
    const bgColorOpacity = backgroundColor && backgroundColor !== "transparent"
        ? (0, next13_enums_colors_1.default)(backgroundColor, bgOpacity, segment)
        : "transparent";
    const extendedClassNames = (0, utils_1.extendTextInfoClassNames)(Object.assign({ segment, kind: normalizedKind }, restProps));
    const componentClassName = `text${className ? ` ${className}` : ""} text-color--${segment}--${color.toLowerCase()}${extendedClassNames}${custoObjectInfo ? " custo-editable" : ""}`;
    let editModal = null;
    if (custoObjectInfo) {
        editModal = custoObjectInfo.handler(custoObjectInfo.entryPoint);
    }
    return (react_1.default.createElement(Text, { component: normalizedKind === enums_1.TEXT_KIND.HEADING
            ? `${normalizedKind}${level}`
            : normalizedKind, className: componentClassName, dangerouslySetInnerHTML: { __html: text }, onClick: editModal, "data-cy": cyData, style: { color: colorOpacity, backgroundColor: bgColorOpacity } }));
};
TextInfo.propTypes = {
    /**
     * Texto que se mostrará en el componente.
     */
    text: prop_types_1.default.string.isRequired,
    /**
     * TEXT_KIND -> Decidirá si el componente es un heading, paragraph o span.
     */
    kind: prop_types_1.default.string,
    /**
     * TEXT_HEADING_LEVEL -> Si el componente es un heading, se especifica el nivel de este (h1, h2, h3, etc).
     */
    level: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    /**
     * Clase para añadirle estilos extras al icono.
     */
    className: prop_types_1.default.string,
    /**
     * TEXT_COLOR -> Color del texto.
     */
    color: prop_types_1.default.string,
    /**
     * TEXT_SIZE -> Tamaño del texto. Se elegirá entre Title, Display o Caption (cada uno con sus niveles correspondientes).
     */
    size: prop_types_1.default.string,
    /**
     * TEXT_FONT_WEIGHT -> Grosor del texto (Regular, Light o Bold).
     */
    fontType: prop_types_1.default.string,
    /**
     * TEXT_ALIGN -> Alineación del texto (centrado, a la izquierda/derecha o justificado).
     */
    align: prop_types_1.default.string,
    /**
     * TEXT_DISPLAY -> Especifica si el texto es tratado como un elemento block o inline.
     */
    display: prop_types_1.default.string,
    /**
     * TEXT_DECORATION -> Si el texto tendrá subrayado o una línea cruzada.
     */
    decoration: prop_types_1.default.string,
    /**
     * TEXT_BORDER -> Redondeado del texto.
     */
    border: prop_types_1.default.string,
    /**
     * TEXT_COLOR -> Color del fondo del texto.
     */
    backgroundColor: prop_types_1.default.string,
    /**
     * TEXT_OPACITY -> Opacidad del texto.
     */
    opacity: prop_types_1.default.string,
    /**
     * TEXT_OPACITY -> Opacidad del fondo.
     */
    bgOpacity: prop_types_1.default.string,
    /**
     * Objeto para la customización del icono en dev.
     */
    custoObjectInfo: prop_types_1.default.shape({
        componentId: prop_types_1.default.string,
        componentInstance: prop_types_1.default.string,
        editFunction: prop_types_1.default.func,
    }),
    cyData: prop_types_1.default.string,
};
TextInfo.defaultProps = {
    kind: enums_1.TEXT_KIND.SPAN,
    level: enums_1.TEXT_HEADING_LEVEL.H1,
    className: "",
    color: next13_enums_colors_1.COLOR_DICTIONARY.BLACK,
    size: enums_1.TEXT_SIZE.CAPTION2,
    fontType: enums_1.TEXT_FONT_WEIGHT.REGULAR,
    custoObjectInfo: null,
    align: enums_1.TEXT_ALIGN.LEFT,
    border: enums_1.TEXT_BORDER.NONE,
    decoration: enums_1.TEXT_DECORATION.NONE,
    display: enums_1.TEXT_DISPLAY.BLOCK,
    backgroundColor: next13_enums_colors_1.COLOR_DICTIONARY.TRANSPARENT,
    opacity: next13_enums_colors_1.OPACITY[100],
    bgOpacity: next13_enums_colors_1.OPACITY[100],
    cyData: "",
};
exports.default = TextInfo;
//# sourceMappingURL=index.js.map